<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <h3 class="card-title">{{$t('medium_grant.diligence__1_capacity_questionaire')}}</h3>
        <p>{{$t('medium_grant.diligence__2_capacity_questionaire_sub2')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <h4 class="card-title">{{$t('medium_grant.diligence__7_internal_controls')}}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <label><strong>{{$t('medium_grant.diligence__7_internal_controls_a')}}</strong></label>
        <div class="mt-3"></div>
        <radio name="diligence.haveEstablieshedPriorProcedures" value="true" v-model="GrantForm.model.diligence.haveEstablieshedPriorProcedures">
          {{$t('medium_grant.general__yes')}}
        </radio>
        <radio name="diligence.haveEstablieshedPriorProcedures" value="false" v-model="GrantForm.model.diligence.haveEstablieshedPriorProcedures">
          {{$t('medium_grant.general__no')}}
        </radio>
      </div>
      <div class="col-lg-12">
        <div class="mt-3"></div>
        <label><strong>{{$t('medium_grant.diligence__7_internal_controls_b')}}</strong></label>
        <div class="mt-3"></div>
        <radio name="diligence.doKeepInvoicesOutside" value="true" v-model="GrantForm.model.diligence.doKeepInvoicesOutside">
          {{$t('medium_grant.general__yes')}}
        </radio>
        <radio name="diligence.doKeepInvoicesOutside" value="false" v-model="GrantForm.model.diligence.doKeepInvoicesOutside">
          {{$t('medium_grant.general__no')}}
        </radio>
      </div>
      <div class="col-lg-12">
        <div class="mt-3"></div>
        <label><strong>{{$t('medium_grant.diligence__7_internal_controls_c')}}</strong></label>
        <div class="mt-3"></div>
        <radio name="diligence.willYourOrgKeepAccounting" value="true" v-model="GrantForm.model.diligence.willYourOrgKeepAccounting">
          {{$t('medium_grant.general__yes')}}
        </radio>
        <radio name="diligence.willYourOrgKeepAccounting" value="false" v-model="GrantForm.model.diligence.willYourOrgKeepAccounting">
          {{$t('medium_grant.general__no')}}
        </radio>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <div class="mt-3"></div>
        <label><strong>{{$t('medium_grant.diligence__7_internal_controls_d')}}</strong></label>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.model.diligence.describeOrgSystem"
            >
            </textarea>
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-3"></div>
        <label><strong>{{$t('medium_grant.diligence__7_internal_controls_e')}}</strong></label>
        <div>
          <label>{{$t('medium_grant.diligence__7_internal_controls_e_i')}}</label>
        </div>
        <div class="mt-3"></div>
        <radio name="diligence.doesHaveAdequateSegregation" value="true" v-model="GrantForm.model.diligence.doesHaveAdequateSegregation">
          {{$t('medium_grant.general__yes')}}
        </radio>
        <radio name="diligence.doesHaveAdequateSegregation" value="false" v-model="GrantForm.model.diligence.doesHaveAdequateSegregation">
          {{$t('medium_grant.general__no')}}
        </radio>
      </div>
      <div class="col-lg-12">
        <div class="mt-3"></div>
        <div>
          <label>{{$t('medium_grant.diligence__7_internal_controls_e_ii')}}</label>
        </div>
        <div class="mt-3"></div>
        <radio name="diligence.doesPersonApprovePaymentsSignatory" value="true" v-model="GrantForm.model.diligence.doesPersonApprovePaymentsSignatory">
          {{$t('medium_grant.general__yes')}}
        </radio>
        <radio name="diligence.doesPersonApprovePaymentsSignatory" value="false" v-model="GrantForm.model.diligence.doesPersonApprovePaymentsSignatory">
          {{$t('medium_grant.general__no')}}
        </radio>
      </div>
      <div class="col-lg-12">
        <div class="mt-3"></div>
        <div>
          <label>{{$t('medium_grant.diligence__7_internal_controls_e_iii')}}</label>
        </div>
        <div class="mt-3"></div>
        <radio name="diligence.isPersonRecipientOfGoods" value="true" v-model="GrantForm.model.diligence.isPersonRecipientOfGoods">
          {{$t('medium_grant.general__yes')}}
        </radio>
        <radio name="diligence.isPersonRecipientOfGoods" value="false" v-model="GrantForm.model.diligence.isPersonRecipientOfGoods">
          {{$t('medium_grant.general__no')}}
        </radio>
        <div class="mt-3">
          <label>{{$t('medium_grant.diligence__7_internal_controls_e_iii_sub')}}</label>
          <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.model.diligence.internalControlsTextSub"
            >
            </textarea>
          </base-input>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
<style scoped>
  p.white-space-pre {
    white-space: pre-wrap;
  }
</style>